<template>
  <div v-if="aplica" class="mt-4 mt-md-5">
    <h3 class="text-dark font-weight-bold mb-3 mb-md-5">{{ titulo }}</h3>
    <p v-if="descripcion" class="text-muted">{{ descripcion }}</p>
    <slot></slot>
  </div>
</template>

<script>
/** Encabezado de sección. El título llega literal desde el Excel. */
export default {
  name: "QSeccion",
  props: {
    titulo: { type: String, required: true },
    descripcion: { type: String, default: "" },
    // una seccion que solo existe en una variante no debe aparecer vacia en la otra
    aplica: { type: Boolean, default: true },
  },
};
</script>
